import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Building2, Mail, Phone, Trash2, MailCheck, MailX } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Row = ({ label, value }) => (
  <div className="text-sm"><span className="text-slate-500">{label}:</span> <span className="font-medium text-slate-800">{Array.isArray(value) ? value.join(", ") || "-" : value || "-"}</span></div>
);

const EnquiryCard = ({ e, onDelete }) => (
  <article className="space-y-3 rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={`contract-enquiry-${e.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 className="font-bold text-slate-900">{e.name}{e.company ? ` - ${e.company}` : ""}</h3>
        <p className="text-xs text-slate-500">{new Date(e.created_at).toLocaleString("en-GB")}</p>
      </div>
      <div className="flex items-center gap-3">
        {e.email_sent ? <MailCheck className="h-4 w-4 text-green-500" aria-label="Email sent" /> : <MailX className="h-4 w-4 text-slate-300" aria-label="Email not sent" />}
        <button onClick={() => onDelete(e.id)} aria-label="Delete enquiry" className="text-slate-400 hover:text-red-600" data-testid={`contract-delete-${e.id}`}><Trash2 className="h-4 w-4" /></button>
      </div>
    </div>
    <div className="flex flex-wrap gap-4 text-sm">
      <a href={`mailto:${e.email}`} className="inline-flex items-center gap-1.5 text-sky-700 hover:underline"><Mail className="h-4 w-4" />{e.email}</a>
      <a href={`tel:${e.phone}`} className="inline-flex items-center gap-1.5 text-sky-700 hover:underline"><Phone className="h-4 w-4" />{e.phone}</a>
    </div>
    <div className="grid gap-1 sm:grid-cols-2">
      <Row label="Properties" value={e.properties} />
      <Row label="Frequency" value={e.frequency} />
      <Row label="Property types" value={e.propertyTypes} />
      <Row label="Services" value={e.services} />
      <Row label="Areas" value={e.areas} />
    </div>
    {e.message && <p className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700">{e.message}</p>}
  </article>
);

const AdminContractEnquiries = () => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/admin/contract-enquiries`, { withCredentials: true }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Delete this enquiry?")) return;
    await axios.delete(`${API}/admin/contract-enquiries/${id}`, { withCredentials: true }).catch(() => {});
    load();
  };

  if (!items) return <div className="py-16 text-center text-slate-500">Loading...</div>;
  return (
    <div className="space-y-4" data-testid="admin-contract-enquiries">
      <div className="flex items-center gap-2 text-slate-700"><Building2 className="h-5 w-5 text-sky-600" /><h2 className="font-bold">Landlord & agent contract enquiries ({items.length})</h2></div>
      {items.length === 0 ? <p className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-500" data-testid="contract-enquiries-empty">No contract enquiries yet.</p>
        : items.map((e) => <EnquiryCard key={e.id} e={e} onDelete={remove} />)}
    </div>
  );
};

export default AdminContractEnquiries;
